<template>
  <div>
    <v-progress-linear 
      indeterminate 
      :color="color"
    />
    <div 
      :class="`text-center ${!textColor || textColor + '--text'}`"
      class="text-center"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingBar',
  props: {
    text: {
      type: String,
      default: 'Loading...'
    },
    color: {
      type: String,
      default: 'primary'
    },
    textColor: String,
  },
  data () {
    return {}
  }
}
</script>